import React from "react";
import CartInput from "./CartInput";
import MenuCardInput from "./MenuCardInput";
import MenuOptionInput from "./MenuOptionInput";
import MenuOptionListInput from "./MenuOptionListInput";

const InputNumber = props => {
  switch (props.type) {
    case "cart":
      return <CartInput {...props} />;
    case "option":
      return <MenuOptionInput {...props} />;
    case "option-list":
      return <MenuOptionListInput {...props} />;
    default:
      return <MenuCardInput {...props} />;
  }
};

export default InputNumber;
